import { RelatedResource, ShareRequest } from '@sharefiledev/sharing-pilet-sdk/api';

export function getRelatedResourcesSharePayload(
	principalRIDs: string[],
	relatedResourcesToShare: RelatedResource[]
) {
	const combinedRelatedResourcesToShare: { [rid: string]: string[] } = {};

	if (relatedResourcesToShare !== undefined && relatedResourcesToShare.length > 0) {
		// Combine resources by rid because same resource can appear twice in RelatedResources with read and share permission
		relatedResourcesToShare
			.filter(resource => resource.permissions && resource.permissions.length > 0)
			.forEach(resource => {
				if (resource.rid in combinedRelatedResourcesToShare) {
					combinedRelatedResourcesToShare[resource.rid].push(...resource.permissions!);
				} else {
					combinedRelatedResourcesToShare[resource.rid] = resource.permissions!;
				}
			});
	}

	const relatedResourcesSharePayload: ShareRequest[] = Object.entries(
		combinedRelatedResourcesToShare
	).map(([rid, permissions]) => {
		return {
			rids: [rid],
			principalRIDs,
			sendEmailNotification: false,
			permissions: permissions ?? [],
		};
	});

	return relatedResourcesSharePayload;
}

export function capitalizeFirstLetter(string: String) {
	return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}
